import React, {useState, memo} from 'react';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';
import {Subhead, Caption2, Body} from '../../../components/Typography';
import renderCurrentOpenStatus from '../../LocationSelector/utils/renderCurrentOpenStatus';

const Wrapper = styled.div`
  display: grid;
  grid-gap: 32px;
  margin-top: 24px;
  align-items: center;

  @media (max-width: 786px) {
    margin-top: 0;
    padding: 20px;
    z-index: 999;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr auto;
  justify-content: space-between;
  align-items: center;

  :last-child {
    margin-bottom: 20px;
  }
`;

const Label = styled(Body)`
  color: #737a87;
  font-weight: 600;
  align-self: flex-start;
`;

const HoursWrapper = styled(Collapse)`
  grid-column: 2 / -1;
`;

const HoursRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

const DayOfWeek = styled(Caption2)`
  text-transform: capitalize;
`;

const HoursTypeTitle = styled(Subhead)`
  margin-bottom: 8px;
  margin-top: 15px;
`;

const ChildLocationDetails = ({location}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleHoursClick = event => {
    event.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <Wrapper>
      <Row onClick={handleHoursClick}>
        <Label id="LocationDetails-Hours">Hours</Label>
        <Caption2>{renderCurrentOpenStatus(location)}</Caption2>
        <i className={`fal fa-chevron-${isExpanded ? 'down' : 'right'}`} />
        <HoursWrapper in={isExpanded}>
          <HoursTypeTitle id="LocationDetails-StoreHours">
            Store Hours
          </HoursTypeTitle>
          {Object.keys(location.hours).map(dayOfWeek => {
            return (
              <HoursRow key={dayOfWeek}>
                <DayOfWeek>{dayOfWeek}</DayOfWeek>
                <Caption2>
                  {location.hours[dayOfWeek][0] &&
                  location.hours[dayOfWeek][0].length
                    ? location.hours[dayOfWeek][0]
                    : 'Closed'}
                </Caption2>
              </HoursRow>
            );
          })}
          <HoursTypeTitle id="LocationDetails-OrderingHours">
            Ordering Hours
          </HoursTypeTitle>
          {Object.keys(location.ordering_hours).map(dayOfWeek => {
            return (
              <HoursRow key={dayOfWeek}>
                <DayOfWeek>{dayOfWeek}</DayOfWeek>
                <Caption2>
                  {location.ordering_hours[dayOfWeek][0] &&
                  location.ordering_hours[dayOfWeek][0].length
                    ? location.ordering_hours[dayOfWeek][0]
                    : 'Closed'}
                </Caption2>
              </HoursRow>
            );
          })}
        </HoursWrapper>
      </Row>
      <Row>
        <Label id="LocationDetails-PhoneLabel">Phone</Label>
        <Caption2>{location.phone}</Caption2>
        <i className="fas fa-phone" />
      </Row>
      <Row>
        <Label id="LocationDetails-AddressLabel">Address</Label>
        <div>
          <Caption2 id="LocationDetails-Location">{location.line1}</Caption2>
          <Caption2>
            {location.city}, {location.state}
          </Caption2>
          <Caption2 id="LocationDetails-Zip">{location.zip}</Caption2>
        </div>
        <i className="fas fa-map-marker-alt" />
      </Row>
    </Wrapper>
  );
};

export default memo(ChildLocationDetails);
